import { render, staticRenderFns } from "./FilePDFIcon.vue?vue&type=template&id=d661f08c&scoped=true"
var script = {}
import style0 from "./FilePDFIcon.vue?vue&type=style&index=0&id=d661f08c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d661f08c",
  null
  
)

export default component.exports